import { Box } from '@/components';
import {
  AutoComplete as AntAutoComplete,
  type AutoCompleteProps,
  Input,
} from 'antd';
import type { BaseOptionType as AntBaseOptionType } from 'antd/es/select';
import type { RefCallBack } from 'react-hook-form';

export type AutoCompleteOptionType = AntBaseOptionType;

type Props<T extends AutoCompleteOptionType> = AutoCompleteProps<string, T> & {
  onSearch: (searchString: string) => Promise<void>;
  loading?: boolean;
  innerRef?: RefCallBack;
};

export const AutoComplete = <T extends AutoCompleteOptionType>(
  props: Props<T>,
) => {
  const { onSearch, options, innerRef, loading, ...autoCompleteProps } = props;

  return (
    <AntAutoComplete
      ref={innerRef}
      options={options?.map((option, index) => ({
        ...option,
        key: `${option.value}-${index}`,
        label: <Box whiteSpace="wrap">{option.label}</Box>,
      }))}
      {...autoCompleteProps}
    >
      <Input.Search onSearch={onSearch} loading={loading} />
    </AntAutoComplete>
  );
};
